export interface UserChart {
  id: string;
  name: string;
  sequence: string;
  selected: boolean;
}
